
    import './styles.scoped.css';
    export default {
  "flashbar": "awsui_flashbar_1q84n_t6t3e_3",
  "flash": "awsui_flash_1q84n_t6t3e_3",
  "flash-refresh": "awsui_flash-refresh_1q84n_t6t3e_39",
  "flash-body": "awsui_flash-body_1q84n_t6t3e_56",
  "flash-text": "awsui_flash-text_1q84n_t6t3e_62",
  "flash-icon": "awsui_flash-icon_1q84n_t6t3e_67",
  "flash-message": "awsui_flash-message_1q84n_t6t3e_72",
  "flash-header": "awsui_flash-header_1q84n_t6t3e_79",
  "flash-content": "awsui_flash-content_1q84n_t6t3e_83",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_t6t3e_87",
  "dismiss-button": "awsui_dismiss-button_1q84n_t6t3e_87",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_t6t3e_98",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_t6t3e_104",
  "action-button": "awsui_action-button_1q84n_t6t3e_98",
  "flash-type-success": "awsui_flash-type-success_1q84n_t6t3e_117",
  "flash-type-error": "awsui_flash-type-error_1q84n_t6t3e_121",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_t6t3e_125",
  "flash-type-info": "awsui_flash-type-info_1q84n_t6t3e_129"
};
  